<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Loan & Contributions Form</h3>
           </template>
           <nav class="row">
              <ol class="breadcrumb arr-right bg-breadcrum">
                 <li class="breadcrumb-item">
                  <a href="#" @click="$router.push('/')"><i class="fa fa-home"></i>&nbsp;Dashboard</a>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/contributions/list">Loan & Contributions List</router-link>
                 </li>
                 <li class="breadcrumb-item active">Loan & Contribution Form</li>
              </ol>
           </nav>
           <hr style="margin-top:-10px" />
           <div class="alert alert-info">
              <strong>NOTE :</strong>
              <p>Note: Input Zero(0) for blank if not inlucded in loan and contributions</p>
            </div>
           <form @submit.prevent="formSubmit">
                    <div class="col-md-12"></div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Select Employee</label>
                            <select class="form-control" v-model="employee_id" @click="employeeIdHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.employee_id}">
                                <option value="">-- Select One --</option>
                                <option v-for="emp in employees" v-bind:value="emp.id">{{emp.full_name | capitalize}}</option>
                            </select>
                            <span v-if="error_handler.employee_id" class="invalid-feedback">{{ error_handler.employee_id[0] }}</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <p>SSS Contribution:</p>
                        <input type="number" v-model="sss_cont"  class="form-control" @click="sss_contHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.sss_cont}">  
                        <span v-if="error_handler.sss_cont" class="invalid-feedback">{{ error_handler.sss_cont[0] }}</span>
                      </div>  
                    </div>
                   <div class="col-md-4">
                      <div class="form-group">
                        <p>PHIC Contribution:</p>
                        <input type="number" v-model="phic_cont" class="form-control" @click="phic_contHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.phic_cont}">  
                        <span v-if="error_handler.phic_cont" class="invalid-feedback">{{ error_handler.phic_cont[0] }}</span>
                      </div>  
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <p>HDMF/Pagibig Contributions:</p>
                        <input type="number" v-model="hdmf_cont" class="form-control" @click="hdmf_contHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.hdmf_pagibig_cont}">  
                        <span v-if="error_handler.hdmf_pagibig_cont" class="invalid-feedback">{{ error_handler.hdmf_pagibig_cont[0] }}</span>
                      </div>  
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <p>HMO:</p>
                        <input type="number" v-model="hmo" class="form-control" @click="hmoHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.hmo}">  
                        <span v-if="error_handler.hmo" class="invalid-feedback">{{ error_handler.hmo[0] }}</span>
                      </div>  
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <p>SSS Loan:</p>
                        <input type="number" v-model="sss_loan" class="form-control" @click="sss_loanHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.sss_loan}">  
                        <span v-if="error_handler.sss_loan" class="invalid-feedback">{{ error_handler.sss_loan[0] }}</span>
                      </div>  
                    </div>
                     <div class="col-md-4">
                      <div class="form-group">
                        <p>HDMF/Pagibig Loan:</p>
                        <input type="number" v-model="hdmf_loan" class="form-control" @click="hdmf_loanHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.hdmf_loan}">  
                        <span v-if="error_handler.hdmf_loan" class="invalid-feedback">{{ error_handler.hdmf_loan[0] }}</span>
                      </div>  
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <p>Withholding Tax:</p>
                        <input type="number" v-model="tax" class="form-control" @click="taxHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.withholding_tax}">  
                        <span v-if="error_handler.withholding_tax" class="invalid-feedback">{{ error_handler.withholding_tax[0] }}</span>
                      </div>  
                    </div>
                     <div class="col-md-4">
                      <div class="form-group">
                        <p>Others:</p>
                        <input type="number" v-model="others" class="form-control" @click="othersHide" v-bind:class="{ 'is-invalid': error_handler && error_handler.others}"> 
                        <span v-if="error_handler.others" class="invalid-feedback">{{ error_handler.others[0] }}</span> 
                      </div>  
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-info" style="width: 100%"><i class="fa fa-save"></i> Submit Form</button> 
                     </div>
           </form>
        </card>
      </template>
      <script>
      /* eslint-disable */
      import Card from 'src/components/UIComponents/Cards/Card.vue'
      export default {
      components: {
        Card,
      },
      
      data() {
        return {
            sss_cont:'',
            phic_cont:'',
            hdmf_cont:'',
            hmo:'',
            sss_loan:'',
            hdmf_loan:'',
            tax:'',
            others:'',


            employee_id:'',
            employees: [],
          //ERROR_HANDLER
          error_handler: [],
        }
      },
      
      mounted: function () {
         this.get_employees()
      },
      
      methods: {
          employeeIdHide(){
              if (!!this.error_handler.employee_id) this.error_handler.employee_id = false
          },  

          sss_contHide(){
            if (!!this.error_handler.sss_cont) this.error_handler.sss_cont = false
          },

          phic_contHide(){
            if (!!this.error_handler.phic_cont) this.error_handler.phic_cont = false
          },

          hdmf_contHide(){
            if (!!this.error_handler.hdmf_pagibig_cont) this.error_handler.hdmf_pagibig_cont = false
          },

          hmoHide(){
            if (!!this.error_handler.hmo) this.error_handler.hmo = false
          },

          sss_loanHide(){
            if (!!this.error_handler.sss_loan) this.error_handler.sss_loan = false
          },

          hdmf_loanHide(){
            if (!!this.error_handler.hdmf_loan) this.error_handler.hdmf_loan = false
          },

          taxHide(){
            if (!!this.error_handler.withholding_tax) this.error_handler.withholding_tax = false
          },

          othersHide(){
            if (!!this.error_handler.others) this.error_handler.others = false
          },

          get_employees() {
                axios.get('api/active/employee')
                .then(response => {
                    this.employees = response.data;
                })
                .catch(error => {
                    console.log(error.response)
                });
            },
            formSubmit() {
                this.$swal({
                    title: 'Are you sure?',
                    text: 'Do you want to submit this request',
                    type: 'warning',
                    showCancelButton: true,
                    showCloseButton: false,
                })
                    .then((isConfirm) => {
                        if (isConfirm === true) {
                              axios.post('api/contributions/create',{
                                    employee_id:this.employee_id,
                                    sss_cont:this.sss_cont,
                                    phic_cont:this.phic_cont,
                                    hdmf_pagibig_cont:this.hdmf_cont,
                                    hmo:this.hmo,
                                    sss_loan:this.sss_loan,
                                    hdmf_loan:this.hdmf_loan,
                                    withholding_tax: this.tax,
                                    others: this.others,
                                })
                                .then(resp => {
                                if(resp.data.response == 'success'){
                                    this.$swal('Save', resp.data.message , 'success')
                                    this.$router.push({
                                       name: 'contributions-list'
                                    })
                                   
                                }else if(resp.data.response == 'error'){
                                    this.$swal('Error',resp.data.message,'error')
                                }                   
                            })    
                            .catch(error => {
                               if (error.response.status == 422){
                                    this.error_handler = error.response.data.errors 
                               }
                                console.log(error); 
                            });   
                        }
                    });
                }
        }
      }
      </script>
      


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contributions/todo-contributions-form.vue